import { Effect, Layer, Scope } from "effect";
import { AtomRegistry } from "effect/unstable/reactivity";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { RecordingApi } from "../api/recording/service.ts";
import { QueryWork } from "../state/query-work.ts";
import { makeSessionOwner } from "../state/session-owner.ts";
import { RecordingFrameIo, RecordingVideoSessions } from "./video-service.ts";
import { makeRecordingVideo } from "./video-operations.ts";
export const RecordingFrameIoLive = Layer.succeed(RecordingFrameIo, RecordingFrameIo.of({
    decodeJpeg: bytes => Effect.tryPromise({ try: () => createImageBitmap(new Blob([Uint8Array.from(bytes)], { type: "image/jpeg" })), catch: () => resourceUnavailable() }),
    closeBitmap: bitmap => Effect.sync(() => bitmap.close()),
    draw: (canvas, bitmap) => Effect.try({ try: () => { if (canvas.width !== bitmap.width || canvas.height !== bitmap.height) {
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
        } canvas.getContext("2d")?.drawImage(bitmap, 0, 0); }, catch: () => resourceUnavailable() })
}));
export const RecordingVideoSessionsLive = (root: Scope.Scope) => Layer.effect(RecordingVideoSessions, Effect.gen(function* () {
    const owner = yield* makeSessionOwner(root), ports = { api: yield* RecordingApi, io: yield* RecordingFrameIo, queryWork: yield* QueryWork, registry: yield* AtomRegistry.AtomRegistry };
    return RecordingVideoSessions.of({ open: (target, timeline) => owner.open(makeRecordingVideo(root, target, timeline, ports)) });
}));
